<!-- RecursiveTable.vue -->
<template>
  <v-data-table fixed-header  height="55vh"
    :headers="headers"
    dense
    :search="search"
    class="mt-3 p-1"
    :items="parametersList"
    :expanded.sync="expanded"
    item-key="id"
    show-expand
    :loading="isLoading"
    loading-text="Loading... Please wait"
  >
    <template v-slot:top>
      <span>
        <v-row>
          <v-col cols="12" md="4"></v-col>
          <v-col cols="12" md="4"></v-col>
          <v-col cols="12" md="4" class="mb-4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </span>
    </template>
    <template #item.data-table-expand="{ item, expand, isExpanded }">
      <tr v-if="item.sub_parameters.length > 0" class="text-start">
        <v-btn
          icon
          title="Sub Categories"
          @click="expand(!isExpanded)"
          class="v-data-table__expand-icon"
          :class="{
            'v-data-table__expand-icon--active': isExpanded,
          }"
        >
          <v-icon :color="isExpanded ? 'primary' : ''"
            >mdi-chevron-down-circle</v-icon
          >
        </v-btn>
      </tr>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="pa-4 mb-4">
        <div>
          SUB CATEGORY LIST:
          <span class="font-weight-bold">{{ item.parameter_name }}</span>
        </div>
        <recursive-table
          :parametersList="item.sub_parameters"
          @editItemData="editItemData"
        ></recursive-table>
      </td>
    </template>

    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-switch
          v-model="item.is_active"
          height="0px"
          title="Update Status"
          dense
          color="success"
          @change="isactiveupdate(item)"
        ></v-switch>
        <v-btn depressed icon title="Edit" @click="editItem(item)">
          <v-icon small color="primary"> mdi-content-save-edit-outline </v-icon>
        </v-btn>
        <v-icon
          v-if="!item.sub_parameters.length > 0"
          color="grey"
          class="mr-2"
          @click="nextpage(item)"
        >
          mdi-chevron-right-circle
        </v-icon>
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "RecursiveTable",
  props: {
    parametersList: Array, // Hierarchical data structure
  },
  data() {
    return {
      search: "",
      expanded: [],
      isLoading: false,
      headers: [
        { text: "", value: "data-table-expand", width: 30 },
        {
          text: "Id",
          value: "id",
          width: 80,
          align: "start",
          groupable: false,
        },
        {
          text: "Parameter name",
          value: "parameter_name",
          width: 250,
          groupable: false,
        },
        {
          text: "Parameter Code",
          value: "parameter_code",
          width: 150,
          groupable: false,
        },
        {
          text: "Description",
          value: "description",
          width: 250,
          groupable: false,
        },

        // { text: "Active", value: "is_active", sortable: false, width: 150 },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: 200,
          groupable: false,
        },
      ],
    };
  },
  methods: {
    toggleRow(item) {
      this.$set(item, "expanded", !item.expanded);
    },
    editItem(item) {
      this.$emit("editItemData", item);
    },
    editItemData(item) {
      this.$emit("editItemData", item);
    },
    nextpage(item) {
      console.log("item " + item);
      this.$router.push({
        name: "Master Data Value",
        query: {
          code: item.parameter_code,
          name: item.parameter_name,
          id: item.id,
        },
      });
    },
  },
};
</script>
<style scoped></style>
